"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
const styles = (theme) => (0, core_1.createStyles)({
    socialItem: {
        paddingTop: theme.spacing(),
        paddingBottom: theme.spacing(),
        paddingLeft: `0 !important`,
        paddingRight: `0 !important`
    },
    paper: {
        height: theme.spacing(6),
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        borderStyle: 'solid',
        borderRadius: 5,
        borderWidth: 1,
        borderColor: theme.palette.text.disabled.getLowEmphasis()
    },
    logo: {
        width: 36,
        height: 36,
        marginLeft: theme.spacing(),
        marginRight: theme.spacing(2)
    },
    buttonSection: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingRight: theme.spacing()
    },
    connectedText: {
        marginLeft: theme.spacing(),
        marginRight: theme.spacing()
    }
});
exports.default = styles;
//# sourceMappingURL=SocialConnectItemStyle.js.map